let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("77OtH")).then(() => parcelRequire('lzczy'));